module.exports = __webpack_public_path__ + "img/floating_icon.97235c7a.jpg";